export class WorkOrder {
    id: number;
    code: string;
    description: string;
    statusCode: string;
    statusDescription: string;
    scheduledEndDate: Date;
}
